export class ScpAuditSerialEntity{

    id:number;
    palletId:number;
    serial:string;
    mac:string;
    sapCode:string;
    description:string;
    technical:string;
    repairDate:string;
    scrapMotif:string;
    state:string;
    stateMotif:string;
    userId:number;
    creationDate:string;
    active:boolean;

    constructor (){}
}